import { render, staticRenderFns } from "./history-quote.vue?vue&type=template&id=5231323e&scoped=true"
import script from "./history-quote.vue?vue&type=script&lang=js"
export * from "./history-quote.vue?vue&type=script&lang=js"
import style0 from "./history-quote.vue?vue&type=style&index=0&id=5231323e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5231323e",
  null
  
)

export default component.exports